import { defineMessages } from "react-intl";

const PREFIX = "AdminBlockPage";
export default defineMessages({
  header: {
    id: `${PREFIX}.header`,
    defaultMessage: "User's list",
  },
  passExpPeriodFormHeader: {
    id: `${PREFIX}.passExpPeriodFormHeader`,
    defaultMessage: "Password expiration period, month",
  },
  passExpPeriodFormHelper: {
    id: `${PREFIX}.passExpPeriodFormHeader`,
    defaultMessage: "Enter duration between 1 and 12 months",
  },
  responseErrorPeriodIncorrect: {
    id: `${PREFIX}.responseErrorPeriodIncorrect`,
    defaultMessage: "The period is set incorrectly",
  },
  addUserFormHeader: {
    id: `${PREFIX}.addUserFormHeader`,
    defaultMessage: "Add user form",
  },
  editUserFormHeader: {
    id: `${PREFIX}.editUserFormHeader`,
    defaultMessage: "Edit user form",
  },
  saveButton: {
    id: `${PREFIX}.save`,
    defaultMessage: "Save",
  },
  cancelButton: {
    id: `${PREFIX}.cancelButton`,
    defaultMessage: "Cancel",
  },
  addUserButton: {
    id: `${PREFIX}.addUserButton`,
    defaultMessage: "Add new user",
  },
  setPasswordExpButton: {
    id: `${PREFIX}.setPasswordExpButton`,
    defaultMessage: "Set password expiration period",
  },
  editButton: {
    id: `${PREFIX}.editButton`,
    defaultMessage: "Edit",
  },
  deleteButton: {
    id: `${PREFIX}.deleteButton`,
    defaultMessage: "Delete",
  },
  login: {
    id: `${PREFIX}.login`,
    defaultMessage: "Login",
  },
  name: {
    id: `${PREFIX}.name`,
    defaultMessage: "Name",
  },
  surname: {
    id: `${PREFIX}.surname`,
    defaultMessage: "Surname",
  },
  department: {
    id: `${PREFIX}.department`,
    defaultMessage: "Department",
  },
  fieldIsRequired: {
    id: `${PREFIX}.fieldIsRequired`,
    defaultMessage: "The field is required",
  },
  checkCorrectness: {
    id: `${PREFIX}.checkCorrectness`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  confirmDialogContent: {
    id: `${PREFIX}.dialog.content`,
    defaultMessage: `Are you sure to delete user {name} {surname}?`,
  },
  confirmDialogBtnYes: {
    id: `${PREFIX}.dialog.btn.yes`,
    defaultMessage: "Yes",
  },
  confirmDialogBtnNo: {
    id: `${PREFIX}.dialog.btn.no`,
    defaultMessage: "No",
  },
  responseErrorAdminDuplicateEmail: {
    id: `${PREFIX}.response.error.admin.duplicate.email`,
    defaultMessage: "The e-mail is already registered",
  },
  emailNotInSystem: {
    id: `${PREFIX}.error.emailNotInSystem`,
    defaultMessage: "Sorry, this email can not be registered in the system.",
  },
});
